import {
  Canvas,
  Checklist,
  Locale,
  Role,
  Site,
  Subscription,
} from '@ritabygglov/core';
import { createContext, useContext } from 'react';

export const defaultValue: UserContext = {
  name: '',
  email: '',
  roles: [Role.User],
  userId: 0,
  canvases: [],
  checklists: [],
  subscriptions: [],
  isAuthenticated: false,
  isSubscribed: false,
  isAcceptingMarketing: false,
  locale: 'sv',
  site: 'ritabygglov',
  setIsAuthenticated: () => {},
  signOut: () => {},
  fetchUser: () => {},
  createdAt: '',
  lastSeenAt: '',
  activeDays: 0,
};

export interface UserContext {
  name: string;
  email: string;
  roles: Role[];
  userId: number;
  canvases: Canvas[];
  checklists: Checklist[];
  subscriptions: Subscription[];
  isSubscribed: boolean;
  isAcceptingMarketing: boolean;
  locale: Locale;
  site: Site;
  createdAt: string;
  lastSeenAt: string;
  activeDays: number;
  isAuthenticated: boolean;
  setIsAuthenticated: VoidFunction;
  signOut: VoidFunction;
  fetchUser: VoidFunction;
}

export type UserData = Omit<
  UserContext,
  'isAuthenticated' | 'setIsAuthenticated' | 'signOut' | 'fetchUser'
>;

export const UserContext = createContext<UserContext>(defaultValue);

export const useUser = () => useContext(UserContext);
